/* template */
<template><div class="search-container"><mpx-image src="https://ut-static.udache.com/webx/sfc/4ejT4H0V2xrEnrMA0wM0_.png" class="search-icon"/><mpx-input type="text" :value="(keywords)" :placeholder="(placeholder)" @input="search" class="search"/><mpx-view @tap="clear" v-show="(keywords)" class="clear"><mpx-image src="https://dpubstatic.udache.com/static/dpubimg/oXTzcUM0JPGZ6UAQybX26.png" class="clear-icon"/></mpx-view></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m30666ece"}'>
  .search-container
    display flex
    padding 0 16px
    align-items center
    height 45px
    background #ffffff
    position relative
    z-index 99
  .search-icon
    position absolute
    left 31px
    height 21px
    width 21px
    top 50%
    transform translateY(-50%)
  .search
    padding-left 41px
    flex 1
    height 44px
    font-size 14px
    background #F6F7F8
    border-radius 8px
    border 1px solid #1473FF
    box-sizing border-box
  .clear
    position absolute
    right 16px
    z-index 100
    margin 12px
    display flex
    align-items center
    top 0
  .clear-icon
    width 20px
    height 20px
  input::-webkit-input-placeholder
    color #666666
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m30666ece"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./searchInput.mpx.js?isComponent&outputPath=components%2FsearchInput30666ece%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./searchInput.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2FsearchInput30666ece%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m30666ece"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/searchInput30666ece/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-input':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-input.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
